export const BACKEND_URL = process.env.REACT_APP_BASE_URL;
export const API_URL = `${BACKEND_URL}/api/v1`;
export const AIRLINE_COUNTRY_CODE = process.env.REACT_APP_AIRLINE_COUNTRY_CODE || "VN";
export const NAV_HEIGHT = '3.3rem';
export const LAYOUT_HEIGHT = '77vh';
export const DASHBOARD_TIMER_INTERVAL = '1800000'; //30 MINUTES
export const TIMEZONE_OFFSET_MINUTES = 420;
export const TIMEZONE = 'Asia/Ho_Chi_Minh';
export const OTP_DELAY_MINUTES = 15;
export const MAXIMUM_TAT_MINUTES = 150;
export const REPORTING_MINUTES = 60;
export const INT_REPORTING_MINUTES = 75;
export const DOM_REPORTING_MINUTES = 60;
export const DEBRIEFING_MINUTES = 15;
export const DIVERT_RETURN_STATUS = ['Diverted', 'Forced Return (Air)', 'Forced Return (Ramp)'];
export const HOME_BASES = ['SGN', 'HAN', 'DAD', 'CXR'];
export const INVOICE_OFFSET_HOURS = 120;
export const PREORDER_COMMISSION_RATE = 0.05;
export const DIRECT_COMMISSION_RATE = 0.1;